import { useQuery } from 'react-query';
import organizerRepository from 'modules/organizer/domain/repositories/organizer-repository';
import { useSelector } from 'react-redux';
import { authStoreUserTournamentId } from 'modules/auth/store/selectors';

export function useFetchActivePlan() {
  const userTournamentId = useSelector(authStoreUserTournamentId);

  return useQuery({
    queryKey: ['activePlan', userTournamentId],
    queryFn: () => {
      if (!userTournamentId) return Promise.resolve(null);
      return organizerRepository.fetchActivePaidSubscription(userTournamentId);
    },
    enabled: !!userTournamentId,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
  });
}
